
// import qs from 'qs'
import {/* getBrowserLanguage, */ getQueryVariable,/*  getBrowserDefaultLanguage, isMobile, */ isValidIP,/*  storageGetItem, storageRemoveItem, storageSetItem, */prop} from '../../utils/utils'
import { get, /* post */ } from './tools';


class BaseUrlApis {
  constructor() {
    this.CPDFURI                = '';
    this.cfgPromise             = null;
    this.server_config          = this.getQueryVariable('server_config');
    this.getQueryVariable       = this.getQueryVariable.bind(this);
    this.getCwsBaseUrlByBaseUrl = this.getCwsBaseUrlByBaseUrl.bind(this);
    // this.getBaseUrlBy           = this.getBaseUrlBy.bind(this);
    this.getServerConfig          = this.getServerConfig.bind(this);
  }

  getQueryVariable(variable){
    return getQueryVariable(variable);
  };

  getBaseUrl = (noPort) => {
    const href = prop(location, 'href')
    const port = prop(location, 'port')
    let path = prop(location, 'pathname');
    let startPos = prop(location, 'protocol').length + 2;
    let pos = href.indexOf(path, startPos);
    let host = href.substring(0, pos);
    let baseUrl = host + '/';

    if(noPort && port && port.length>0){
      baseUrl = baseUrl.replace(':' + port, '')
    }
    return baseUrl;
  };


  getCwsBaseUrlByBaseUrl(){
    // https://jira.foxitsoftware.cn/browse/PRO-6537
    let baseUrl = this.getBaseUrl(true);
    let isIp = isValidIP(baseUrl);
    let port = prop(location, 'port');
    if (baseUrl.indexOf('localhost') !== -1 || port !== '' || isIp ) {
      baseUrl = 'https://pheecws-azk8s.foxitcloud.com/';
    }
    if (baseUrl.indexOf('http://') !== -1) {
      baseUrl = baseUrl.replace('http://', 'https://');
    }
    // be used for develop env
    if(!!this.server_config){
      const URLS = {
        'p-demo': 'https://pheecws-demo4.connectedpdf.com/',
        'fzk8s':'https://pheecws-fzk8s.connectedpdf.com/',
        'fzk8s01':'https://pheecws-fzk8s01.connectedpdf.com/',
        'pdfonline':'https://pheecws.foxit.com/',
        'online_cn':'https://pheecws.foxitsoftware.cn/',
        'azk8s': 'https://pheecws-azk8s.foxitcloud.com/'
      }
      let url = URLS[this.server_config];
      if(!!url){
        return url;
      }
    }

    // phee: online.foxitsoftware.cn => pheecws.foxitsoftware.cn
    // phee: pdfonline.foxitsoftware.com => pheecws.foxitsoftware.com
    // online.foxitsoftware.cn => pheecws.foxitsoftware.cn
    // https://pheeadmin-fzk8s.connectedpdf.com/api/server-config

    let url = baseUrl.replace(/\/\/\w+\-/, '//pheecws-');
    if(url.indexOf('pheecws') !== -1){
      return url;
    }
    url = baseUrl.replace(/\/\/\w+\./, '//pheecws.');
    return url;
  }

  
  getServerConfig = () => {
    let cwsBaseUrl = this.getCwsBaseUrlByBaseUrl();
    // https://pheeadmin-fzk8s.connectedpdf.com/api/server-config
    // https://cws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    // https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    //let url = cwsBaseUrl + "cpdfapi/v1/server/server-config?v="+(new Date()).valueOf();
    let url = cwsBaseUrl + 'cpdfapi/v1/server/server-config?v=' + new Date().valueOf();
    return get({ url: url,msg:'TCL: getServerConfig -> err',config:{}})
  };

}




export default BaseUrlApis;
